// src/shared/auth/Require.tsx
import { Navigate } from 'react-router-dom';
import { useAuth } from './session';
import type { AbilityKey } from './types';
import type { Role } from './roles';

interface Props {
  ability: AbilityKey | Role;
  mode?: 'ability' | 'role';
  children: React.ReactNode;
}

export default function Require({ ability, mode = 'ability', children }: Props) {
  const { perms, roles, loading, user } = useAuth();
  // Avoid redirect flicker while auth is still loading
  if (loading) return null; // could render a spinner here
  // If not logged in at all, redirect
  if (!user) return <Navigate to="/" replace />;
  const ok = mode === 'ability' ? perms.has(ability as string) : roles.includes(ability as Role);
  return ok ? <>{children}</> : <Navigate to="/" replace />;
}
